<template>
    <div>
        <draggable v-model="registrationCategorySeries" @end="updateOrder">
            <transition-group type="transition" name="flip-list">
                <div v-for="(series,index) in registrationCategorySeries" class="box "
                     :key="series.id">
                    <div class="box-body">
                        <div>

                            <b>Name</b>:{{series.name}}
                        </div>
                        <div>
                            <b>Status</b>:<span class="label" :class="classes[index]">{{getStatus(series,index)}}</span>
                        </div>
                        <div>
                            <b>Closing Date</b>:{{series.closing_date | dateTimeFormat}}
                        </div>
                        <div>
                            <b>Price Range</b>:{{series.price_range }}
                        </div>

                        <div>
                            <b>Capacity</b>:{{series.capacity }}
                        </div>

                        <div>
                            <b>Capacity Remain</b>:{{series.capacity_remain }}
                        </div>
                    </div>
                </div>
            </transition-group>
        </draggable>
    </div>
</template>

<script>

    import draggable from 'vuedraggable'
    import {dateTimeFormat} from '../Utility/filters/dates'
    import Mom from "moment-timezone";

    export default {
        name: "registration-category-series-list",
        props: ['propRegistrationCategorySeries'],
        filters: {
            dateTimeFormat
        },
        data() {
            return {
                registrationCategorySeries: [],
                payload: {},
                classes: []
            }
        },
        components: {
            draggable
        },
        created() {
            this.registrationCategorySeries = this.propRegistrationCategorySeries;
            this.classes.length = this.registrationCategorySeries.length;
        },
        mounted() {
            let temp = this.classes;
            this.classes = null;
            this.classes = temp;
        },
        methods: {
            updateOrder() {
                this.registrationCategorySeries.forEach((series, index) => {
                    this.payload[series.id] = index;
                });

                axios.put('/api/v0/registration_category_series/reorder', {
                    'list_priority': this.payload
                }).then(response => {

                }).catch(error => {
                    alert('Ooops, we have a problem');
                })
            },
            getStatus(series, index) {
                switch (series.human_status) {
                    case 'human_status_open':
                        this.classes[index] = 'bg-green'
                        return 'Open';
                    case 'human_status_closed':
                        this.classes[index] = 'bg-red'
                        return 'Closed';
                    case 'human_status_waiting_list':
                        this.classes[index] = 'bg-orange'
                        return 'Waiting list';
                    case 'human_status_full':
                        this.classes[index] = 'bg-red'
                        return 'Full';
                    case 'human_status_inactive':
                        if (series.active_date === null) {
                            this.classes[index] = 'bg-red'
                            return 'Inactive'
                        }
                        if (series.active_date != null) {
                            this.classes[index] = 'bg-orange'
                            return 'Opens in ' + this.formatTime(series.active_date) + ' week(s) from now'
                        }
                }
            },
            formatTime(value, timezone, format = "DD/MM/YYYY HH:mm") {
                let now = Mom();
                let eventDate = Mom.tz(value, timezone);
                return eventDate.diff(now, 'weeks');
            }
        },

        computed: {}
    }
</script>
<style>
    .flip-list-move {
        transition: transform 0.5s;
    }
</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategorySeries/List.vue